import axios from "axios";
// Works for both CRA (process.env.REACT_APP_*) and Vite (import.meta.env.VITE_*)
const API_URL =
  process.env.REACT_APP_API_URL || import.meta.env?.VITE_API_URL || "http://127.0.0.1:5002";

if (!API_URL) {
  console.error("API base URL is undefined. Check your .env file!");
}

export const getApiUrl = (endpoint) => {
  return `${API_URL.replace(/\/$/, "")}${endpoint}`;
};

// Auto-retry transient network changes (e.g. ERR_NETWORK_CHANGED, socket resets)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config) return Promise.reject(error);

    const method = (config.method || 'get').toLowerCase();
    const isIdempotent = ['get', 'head', 'options'].includes(method);

    config.__retryCount = config.__retryCount || 0;
    const isNetworkError =
      !error.response &&
      (error.code === 'ERR_NETWORK' ||
        error.message?.includes('Network Error') ||
        error.message?.includes('ERR_NETWORK_CHANGED'));

    if (isIdempotent && isNetworkError && config.__retryCount < 3) {
      config.__retryCount += 1;
      await new Promise((resolve) => setTimeout(resolve, config.__retryCount * 200));
      return axios(config);
    }

    return Promise.reject(error);
  }
);

export const safeApiPost = (endpoint, body, config = {}) =>
  axios.post(getApiUrl(endpoint), body, config);

export const safeApiRequest = (method, endpoint, body, config = {}) =>
  axios.request({ method, url: getApiUrl(endpoint), data: body, ...config });